import $ from 'jquery';

const header = document.querySelector('.home-header');

const setHeaderScroll = () => {
    const pos = window.pageYOffset;

    if (header != null) {
        if (pos > 0 && window.matchMedia('(min-width: 992px)').matches) {
            header.classList.add('site-header--scroll');
        } else {
            header.classList.remove('site-header--scroll');
        }
    }
};

window.addEventListener('load', setHeaderScroll);
window.addEventListener('scroll', setHeaderScroll);
window.addEventListener('resize', setHeaderScroll);

$('.hamburger, .header-nav__closer').on('click', function () {
    $('.header-nav').toggleClass('header-nav--active');
    $('body').toggleClass('menu-active');
    $('.site-header').toggleClass('site-header--menu-active')
    $('.hamburger').toggleClass('hamburger--close-menu')
});

$('.header-nav__overlay-col').on('click', function (e) {
    if (e.target !== e.currentTarget) return;
    $('.header-nav').toggleClass('header-nav--active');
    $('.site-header').toggleClass('site-header--menu-active')
    $('.hamburger').toggleClass('hamburger--close-menu')

    $('body').toggleClass('menu-active');
});

$('.menu-item-has-children > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');
    const currentIcon = $(this).find('i');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
    currentIcon.toggleClass('oreca-icons-plus oreca-icons-minus');
});